/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ContactPageUpdateInput { 
    archived?: boolean;
    communityRoomText?: string;
    createdAt?: string;
    id?: string;
    jobOpportunitiesText?: string;
    leasingEmail?: string;
    leasingPhone?: string;
    locked?: boolean;
    mediaContact?: string;
    officeContactDirections?: string;
    officeContactFax?: string;
    officeContactPhone?: string;
    officeContactTollFree?: string;
    published?: boolean;
    readOnly?: boolean;
    updatedAt?: string;
    version?: number;
}
